import { Pipe, PipeTransform } from '@angular/core';
import { UtilitiesService } from '../../main/services/utilities/utilities.service';

@Pipe({
    name: 'ordersDataFilter'
})
export class OrdersDataFilterPipe implements PipeTransform {
    constructor(public util: UtilitiesService) {

    }
    transform(array: any[], query: string) {
        const _query = this.util.removeDiacritics(query.toLowerCase().trim());
        return array;
        // return array.filter( e => {
        //     return this.util.removeDiacritics(e.Origin.Address.toLowerCase()).indexOf(_query) !== -1 ||
        //         this.util.removeDiacritics(e.Destination.Address.toLowerCase()).indexOf(_query) !== -1;
        // });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/orders-data-filter.pipe.ts